import PropTypes from "prop-types";
import React from "react";
// eslint-disable-next-line import/no-cycle
import { Abbr, CalendarCell, CalendarHead, CalendarRow } from "./styled";

export const Week = ({ labels, namespace }) => (
  <CalendarHead>
    <CalendarRow>
      {labels.map((aWeek) => (
        <CalendarCell
          as="th"
          scope="col"
          title={aWeek.full}
          key={`${namespace}-${aWeek.abbr}`}
        >
          <Abbr title={aWeek.full}>{aWeek.abbr}</Abbr>
        </CalendarCell>
      ))}
    </CalendarRow>
  </CalendarHead>
);

Week.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.shape({ abbr: PropTypes.string, full: PropTypes.string })
  ),
  namespace: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
